const constants = {
  MICR_NOT_LISTED: "[Not listed above]",
};

export default constants;
